import {
    ExternalLink,
    IconButton,
    PopoverWrapper,
    Row,
    TextButton,
    Tooltip,
    useAppPalette,
    usePopover
} from "@bridgesplit/ui";
import { ContrastOutlined } from "@mui/icons-material";

import { DESKTOP_PADDING, FOOTER_LEFT_LINKS, FOOTER_SOCIAL_LINKS, NAV_BREAKPOINT, NAV_Z_INDEX } from "./constants";
import { useNavbarHeight } from "./util";
import { ThemeSwitch } from "./ThemeSwitch";

export default function Footer() {
    const { border, background } = useAppPalette();
    const { footer } = useNavbarHeight();

    return (
        <Row
            spaceBetween
            sx={{
                borderTop: border,
                height: footer + "px",
                background,
                position: "fixed",
                bottom: 0,
                width: "100vw",
                zIndex: NAV_Z_INDEX - 1,
                [NAV_BREAKPOINT.below]: { display: "none" }
            }}
        >
            <Row spacing={3} sx={{ p: DESKTOP_PADDING }}>
                {FOOTER_LEFT_LINKS.map(({ label, link }) => (
                    <ExternalLink key={label} target="_blank" rel="noopener" href={link}>
                        <TextButton color="caption">{label}</TextButton>
                    </ExternalLink>
                ))}
            </Row>
            <Row spacing={3} sx={{ p: DESKTOP_PADDING }}>
                <ThemeEdit />
                {FOOTER_SOCIAL_LINKS.map(({ icon, label, link, showText }) => {
                    if (showText) {
                        return (
                            <ExternalLink key={label} target="_blank" rel="noopener" href={link}>
                                <TextButton color="caption">{label}</TextButton>
                            </ExternalLink>
                        );
                    }
                    return (
                        <Tooltip key={label} title={label}>
                            <ExternalLink target="_blank" rel="noopener" href={link}>
                                <IconButton textColor="caption" textVariant="body1" border={false} jsxIcon={icon} />
                            </ExternalLink>
                        </Tooltip>
                    );
                })}
            </Row>
        </Row>
    );
}

function ThemeEdit() {
    const { open, popoverProps, close } = usePopover();

    return (
        <>
            <PopoverWrapper
                anchorOrigin={{ vertical: -20, horizontal: "center" }}
                transformOrigin={{ vertical: "bottom", horizontal: "center" }}
                sx={{ width: "200px" }}
                {...popoverProps}
            >
                <ThemeSwitch close={close} />
            </PopoverWrapper>
            <Tooltip title="Theme">
                <IconButton
                    onClick={open}
                    textColor="caption"
                    textVariant="body1"
                    border={false}
                    jsxIcon={<ContrastOutlined />}
                />
            </Tooltip>
        </>
    );
}
